import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitConfirmModal"]

  static values = {
    confirmationChecksUrl: String
  }

  refreshConfirmationChecks(event) {
    const productType = event.target.value
    const frame = document.getElementById("qa_confirmation_checks")
    if (!frame) return

    if (!productType) {
      frame.removeAttribute("src")
      frame.innerHTML = "<p class=\"text-sm text-base-content/60\">Select a product type to show confirmation checks.</p>"
      return
    }

    const form = this.formElement
    const formId = form?.id || ""
    const url = new URL(this.confirmationChecksUrlValue, window.location.origin)
    url.searchParams.set("product_type", productType)
    if (formId) url.searchParams.set("form_id", formId)
    frame.src = url.toString()
  }

  openSubmitConfirmation(event) {
    event.preventDefault()
    if (this.hasSubmitConfirmModalTarget) this.submitConfirmModalTarget.showModal()
  }

  cancelSubmitConfirmation() {
    if (this.hasSubmitConfirmModalTarget) this.submitConfirmModalTarget.close()
  }

  confirmSubmit(event) {
    event.preventDefault()

    const form = this.formElement
    if (!form) return

    this.removeHiddenSubmitAction(form)

    const input = document.createElement("input")
    input.type = "hidden"
    input.name = "qa_audit_action"
    input.value = "submit"
    input.dataset.qaAuditSubmitAction = "true"
    form.appendChild(input)

    this.cancelSubmitConfirmation()
    form.requestSubmit()
  }

  removeHiddenSubmitAction(form) {
    form.querySelectorAll('input[data-qa-audit-submit-action="true"]').forEach((element) => element.remove())
  }

  get formElement() {
    return this.element.querySelector("form")
  }
}
